import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './CommentBoxInput.scss';
import { autoformatOpts } from './utils';

const Quill =
    typeof window === 'object' ? require('react-quill').Quill : () => false;

const ReactQuill =
    typeof window === 'object' ? require('react-quill') : () => false;
const AutoFormat =
    typeof window === 'object'
        ? require('quill-autoformat').default
        : () => false;

// eslint-disable-next-line react/prop-types
const CommentBoxInput = ({
    placeholderText,
    handleChange,
    onFocus,
    onBlur,
    editorRef,
}) => {
    let inputRef = useRef();
    if (editorRef) {
        inputRef = editorRef;
    }

    useEffect(() => {
        if (inputRef.current) {
            const quill = inputRef.current.getEditor();
            quill.root.dataset.placeholder = placeholderText;
        }
    }, [placeholderText]);

    useEffect(() => {
        if (inputRef?.current && !editorRef?.current) {
            inputRef.current.focus();
        }
    }, [inputRef, editorRef]);
    useEffect(() => {
        if (inputRef.current) {
            const quill = inputRef.current.getEditor();
            quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
                // eslint-disable-next-line no-param-reassign
                delta.ops = delta.ops.map((op) => {
                    let insert = '';
                    if (
                        typeof op.insert === 'object' &&
                        op.insert !== null &&
                        op.insert.hashtag !== undefined
                    ) {
                        insert = op.insert.hashtag;
                    }

                    if (typeof op.insert === 'string') {
                        insert = op.insert.replace(/\u00a0/g, ' ');
                    }

                    return {
                        insert,
                    };
                });
                return delta;
            });
        }
    }, [inputRef]);

    let modules = {};
    if (ReactQuill) {
        Quill.register('modules/autoFormat', AutoFormat, true);
        modules = {
            toolbar: false,
            autoFormat: autoformatOpts,
        };
    }
    return (
        <div className="component-CommentBoxInput">
            <div className="componentBoxInput-TextArea">
                <form>
                    <ReactQuill
                        onFocus={onFocus}
                        onBlur={onBlur}
                        ref={inputRef}
                        name="commentBoxInput"
                        placeholder={placeholderText}
                        onChange={handleChange}
                        modules={modules}
                    />
                </form>
            </div>
        </div>
    );
};

CommentBoxInput.propTypes = {
    placeholderText: PropTypes.string,
    handleChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    editorRef: PropTypes.shape({ current: PropTypes.any }),
};

CommentBoxInput.defaultProps = {
    editorRef: null,
    placeholderText: '',
    handleChange: () => {},
    onFocus: () => {},
    onBlur: () => {},
};

CommentBoxInput.displayName = 'CommentBoxInput';

export default CommentBoxInput;
